import firebase from './Firebase';
import FirebaseContext from './Context';
export {FirebaseContext};
export default firebase;